import { render, staticRenderFns } from "./comment-filters.vue?vue&type=template&id=0a170ab6&scoped=true"
import script from "./comment-filters.vue?vue&type=script&lang=js"
export * from "./comment-filters.vue?vue&type=script&lang=js"
import style0 from "./comment-filters.vue?vue&type=style&index=0&id=0a170ab6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a170ab6",
  null
  
)

export default component.exports